import listsPersonsService from '@/services/listsPersonsService'

const state = {
  importerProgress: {
    list: '',
    finish: false,
    importType: '',
    show: false,
    index: '',
    totalUsers: ''
  },
  importer: {
    businessId: '',
    file: null,
    headers: [],
    listId: '',
    listName: '',
    importerSelection: '',
    newList: '',
    persons: [],
    step: 1
  },
  list: {},
  listsPersons: [],
  loadingListsPersons: false,
  loadingUsersList: false,
  paginationListsPersons: {},
  paginationUsersList: {},
  searchListsPersons: '',
  searchUsersList: '',
  totalListPersons: 0,
  totalUsersList: 0,
  usersList: []
}

const mutations = {
  'RESET_IMPORTER_PROGRESS' (state) {
    state.importer = {
      file: null,
      headers: [],
      importType: '',
      listId: '',
      listName: '',
      importerSelection: '',
      newList: '',
      persons: [],
      step: 1
    }
  },
  'SET_IMPORTER_PROGRESS' (state, data) {
    state.importerProgress = data
  },
  'CLEAR_IMPORTER_PROGRESS' (state) {
    state.importerProgress = {
      list: '',
      finish: false,
      importType: '',
      show: false,
      index: '',
      totalUsers: ''
    }
  },
  'SET_IMPORTER_FILE' (state, file) {
    state.importer.file = file
  },
  'SET_IMPORTER_HEADERS' (state, value) {
    state.importer.headers = value
  },
  'SET_IMPORTER_BUSINESS_ID' (state, value) {
    state.importer.businessId = value
  },
  'SET_IMPORTER_LIST_ID' (state, value) {
    state.importer.listId = value
  },
  'SET_IMPORTER_LIST_NAME' (state, value) {
    state.importer.listName = value
  },
  'SET_IMPORTER_NEW_LIST' (state, value) {
    state.importer.newList = value
  },
  'SET_IMPORTER_SELECTION' (state, value) {
    state.importer.importerSelection = value
  },
  'SET_IMPORTER_PERSONS' (state, persons) {
    state.importer.persons = persons
  },
  'SET_IMPORTER_STEP' (state, value) {
    state.importer.step = value
  },
  'SET_LIST' (state, list) {
    state.list = list
  },
  'SET_LISTS_PERSONS' (state, listsPersons) {
    state.listsPersons = listsPersons
  },
  'SET_LOADING_LISTS_PERSONS' (state, status) {
    state.loadingListsPersons = status
  },
  'SET_PAGINATION_LISTS_PERSONS' (state, pagination) {
    state.paginationListsPersons = pagination
  },
  'SET_PAGINATION_USERS_LIST' (state, pagination) {
    state.paginationUsersList = pagination
  },
  'SET_SEARCH_LISTS_PERSONS' (state, search) {
    state.searchListsPersons = search
  },
  'SET_SEARCH_USERS_LIST' (state, search) {
    state.searchUsersList = search
  },
  SET_TOTAL_LISTS_PERSONS (state, totalListPersons) {
    state.totalListPersons = totalListPersons
  },
  'SET_TOTAL_USERS_LIST' (state, totalUsersList) {
    state.totalUsersList = totalUsersList
  },
  'SET_USERS_LIST' (state, usersList) {
    state.usersList = usersList
  }
}

const actions = {
  addUsersToList (vuexContext, { companyId, appId, listId, search, advancedSearch }) {
    return new Promise((resolve, reject) => {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      listsPersonsService.addUsersToList(
        vuexContext.getters.token, { companyId: company, appId: app, listId, search, advancedSearch })
        .then(response => {
          resolve(response.list)
        }).catch(error => {
          console.log(error)
        })
    })
  },
  createList (vuexContext, { companyId, appId, listName, listType, importedFrom }) {
    return new Promise((resolve, reject) => {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      listsPersonsService.createList(
        vuexContext.getters.token, {
          companyId: company,
          appId: app,
          listName: listName,
          listType,
          importedFrom
        }).then(response => {
        resolve(response.list)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async createEmptyList (vuexContext, { companyId, appId, listName }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    await listsPersonsService.createEmptyList(
      vuexContext.getters.token,
      company,
      app,
      listName
    )
  },
  getSpecificList (vuexContext, { listId }) {
    return new Promise((resolve, reject) => {
      listsPersonsService.getSpecificList(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        listId).then(response => {
        vuexContext.commit('SET_LIST', response.list)
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getListsPersons (vuexContext) {
    return new Promise((resolve, reject) => {
      vuexContext.commit('SET_LOADING_LISTS_PERSONS', true)
      listsPersonsService.getListsPersons(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        vuexContext.state.paginationListsPersons,
        vuexContext.state.searchListsPersons).then(response => {
        vuexContext.commit('SET_LISTS_PERSONS', response.lists.rows)
        vuexContext.commit('SET_TOTAL_LISTS_PERSONS', response.lists.count)
        vuexContext.commit('SET_LOADING_LISTS_PERSONS', false)
        resolve(true)
      }).catch((error) => {
        vuexContext.commit('SET_LISTS_PERSONS', [])
        vuexContext.commit('SET_TOTAL_LISTS_PERSONS', 0)
        vuexContext.commit('SET_LOADING_LISTS_PERSONS', false)
        console.log(error)
      })
    })
  },
  getUsersOfSpecificList (vuexContext, { listId }) {
    return new Promise((resolve, reject) => {
      listsPersonsService.getUsersOfSpecificList(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        listId,
        vuexContext.state.paginationUsersList,
        vuexContext.state.searchUsersList).then(response => {
        vuexContext.commit('SET_TOTAL_USERS_LIST', response.listUsers.count)
        vuexContext.commit('SET_USERS_LIST', response.listUsers.rows)
        resolve(true)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  importNew (vuexContext, { importType, responsibleId }) {
    return new Promise((resolve, reject) => {
      listsPersonsService.importNew(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid, {
          listId: vuexContext.state.importer.listId,
          file: vuexContext.state.importer.file,
          headers: vuexContext.state.importer.headers,
          importType,
          responsibleId
        }
      ).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updateSpecificList (vuexContext, { companyId, appId, listId, name }) {
    return new Promise((resolve, reject) => {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      listsPersonsService.updateSpecificList(
        vuexContext.getters.token,
        company,
        app,
        listId, { name: name })
        .then(response => {
          resolve(response.list)
        }).catch(error => {
          console.log(error)
        })
    })
  },
  deleteSpecificList (vuexContext, { companyId, appId, listId }) {
    return new Promise((resolve, reject) => {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      listsPersonsService.deleteSpecificList(
        vuexContext.getters.token,
        company,
        app,
        listId
      ).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  deleteUserFromList (vuexContext, { companyId, appId, listId, userId }) {
    return new Promise((resolve, reject) => {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      listsPersonsService.deleteUserFromList(
        vuexContext.getters.token,
        company,
        app,
        listId,
        userId)
        .then(response => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
